import classNames from 'classnames';

import { TOOL_MODES } from './drawingEditorConstants';

/**
 * Returns input-layer classes that apply shared overlay behavior and tool-specific cursor styling.
 */
export const getDrawingInputLayerClassName = (toolMode?: string): string =>
    classNames('drawing-input-layer', {
        DrawingEditorCanvasDrawMode: toolMode === TOOL_MODES.DRAW,
        DrawingEditorCanvasEraseMode: toolMode === TOOL_MODES.ERASE,
    });
